import i18next from 'i18next';
import ar from './navigation-i18n/ar';
import en from './navigation-i18n/en';
import tr from './navigation-i18n/tr';

i18next.addResourceBundle('en', 'navigation', en);
i18next.addResourceBundle('tr', 'navigation', tr);
i18next.addResourceBundle('ar', 'navigation', ar);

const navigationConfig = [// {
  //   id: 'home',
  //   title: '',
  //   type: 'group',
  //   // translate: 'Буйруқ_ва_шартномалар',
  //   icon: 'heroicons-outline:clipboard-list',
  //   children: [
  {
    id: 'home-component', title: 'Бош саҳифа', // translate: 'АСОСИЙ',
    type: 'item', icon: 'heroicons-outline:home', url: 'lawyer/home',
  }, //   ],
  // },

  {
    id: 'offers', title: 'Менинг хужжатларим', type: 'group', // translate: 'Буйруқ_ва_шартномалар',
    icon: 'heroicons-outline:clipboard-list', children: [{
      id: 'offer',
      title: 'Таклифлар',
      translate: 'Таклифлар',
      type: 'item',
      icon: 'heroicons-outline:chat-alt-2',
      url: 'lawyer/offers/offer/all',
    }, {
      id: 'advocacy', title: 'Ҳуқуқий тарғиботлар ', // translate: 'Даъво ариза',
      type: 'item', icon: 'heroicons-outline:inbox', url: 'lawyer/offers/advocacy/all',
    }, {
      id: 'monitoring', title: 'Мониторинг', // title: '  Мониторинг ва ўрганишлар ',
      // translate: 'Даъво ариза',
      type: 'item', icon: 'heroicons-outline:presentation-chart-bar', url: 'lawyer/offers/monitoring/all',
    }],
  }, {
    id: 'command-all',
    title: 'Буйруқ ва шартномалар',
    type: 'group',
    icon: 'heroicons-outline:custom-box', // translate: 'Буйруқ_ва_шартномалар',
    children: [{
      id: 'command-component',
      title: 'command',
      translate: 'Ҳаммаси',
      type: 'item',
      icon: 'heroicons-outline:collection',
      url: 'lawyer/request/all',
    }, {
      id: 'command-contract',
      title: 'contract',
      translate: 'Шартномалар',
      type: 'item',
      icon: 'heroicons-outline:inbox',
      url: 'lawyer/request/contract',
    }, {
      id: 'command-internal',
      title: 'internal',
      translate: 'Буйруқлар',
      type: 'item',
      icon: 'heroicons-outline:inbox-in',
      url: 'lawyer/request/order',
    }],
  }, {
    id: 'court-cases',
    title: 'Суд ишлари',
    type: 'group',
    icon: 'heroicons-outline:archive-box', // translate: 'Буйруқ_ва_шартномалар',
    children: [{
      id: 'claim',
      title: 'claim',
      translate: 'Талабнома',
      type: 'item',
      icon: 'heroicons-outline:document-text',
      url: 'lawyer/claim/all',
    }, {
      id: 'filing', title: 'Даъво ариза', // translate: 'Даъво ариза',
      type: 'item', icon: 'heroicons-outline:archive', url: 'lawyer/law-suit/all',
    }, // {
      //   id: 'appeals',
      //   title: 'Мурожаатлар',
      //   // translate: 'Мурожаатлар',
      //   type: 'item',
      //   icon: 'heroicons-outline:server',
      //   url: 'lawyer/appeals/all',
      // },
      {
        id: 'protest', title: 'Протест ва суд хужжати ', // translate: 'Талабнома',
        type: 'item', icon: 'heroicons-outline:exclamation-circle', url: 'lawyer/protest/all',
      }],
  }, {
    id: 'appeals', title: 'Мурожаатлар', // translate: 'Мурожаатлар',
    type: 'item', icon: 'heroicons-outline:server', url: 'lawyer/appeals/all',
  }, {
    id: 'statistics',
    title: 'Статистика',
    type: 'group',
    icon: 'heroicons-outline:custom-statistics', // translate: 'Буйруқ_ва_шартномалар',
    children: [{
      id: 'statistic-org', title: 'Ташкилотлар кесимида', // translate: 'Ташкилотлар кесимида',
      type: 'item', icon: 'heroicons-outline:library', url: 'lawyer/statistics/org',
    }, {
      id: 'statistic-employer', title: 'Марказ ҳодимлари', // translate: 'Марказ ҳодимлари',
      type: 'item', icon: 'heroicons-outline:user-group', url: 'lawyer/statistics/employer',
    }, // {
      //   id: 'statistic-14a',
      //   title: '14-А асосида',
      //   // translate: 'Марказ ҳодимлари',
      //   type: 'item',
      //   icon: 'heroicons-outline:chart-square-bar',
      //   url: 'lawyer/statistics/based-on-14-а',
      // },
    ],
  }];

export default navigationConfig;
